<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>呂善安，林先生到底在說什麼？</npc>
              <npc :npc-id="0">是謎題。為了避免警察阻止我們，才用這樣隱晦的方式告訴我們，那裡的東西一定能解決現在的難題。</npc>
              <npc :npc-id="1" right>但那地方到底在哪！？</npc>
              <npc :npc-id="0">冷靜思考吧。我們現在正面對著高賓閣，而所謂的扇頭，指的是摺扇握柄的部分——</npc>
              <npc :npc-id="0">⋯⋯</npc>
              <npc :npc-id="0">我知道答案了。小蘇，那地方就在——</npc>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="扇頭指的是摺扇握柄的部分。" morehint="面對高賓閣正面抬頭看，哪裡有扇子呢？">
              <p>右邊扇子，扇頭下方的圓型，是從左數來第幾個圓？（答案請以中文字輸入「第幾個」，如第一個、第二個、第三個⋯⋯）</p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage7_6',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第七章 - 6',
      isQuestion: true,
      stageId: 'fan',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
